import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Navbar from './layout/navbar/Navbar';
import Home from './Pages/Dashboard/Home';
import { useEffect, useState } from 'react';
import PartnerLogin from './Pages/PartnerAccount/login'
import EditSocialLinks from './Pages/Dashboard/Partner/EditSocialLinks';
import Ticket from './Pages/Dashboard/Partner/Ticket';

function App() {
  const [partnerToken, setPartnerToken] = useState(localStorage.getItem('partnerToken') || '');

  useEffect(() => {
    const interval = setInterval(() => {
      const newPartnerToken = localStorage.getItem('partnerToken') || '';
      if (newPartnerToken !== partnerToken) {
        setPartnerToken(newPartnerToken);
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [partnerToken]);

  return (
    <div className="App">
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          {!partnerToken ? (
            <Route path="/PartnerLogin" element={<PartnerLogin />} />
          ) : (
            <>
              <Route path="/PartnerLogin" element={<Home />} />
              <Route path="/edit-socials" element={<EditSocialLinks />} />
              <Route path="/tickets" element={<Ticket />} />
            </>
          )}
        </Routes>
      </Router>
    </div>
  );
}

export default App;
